import dataFieldUtils from '../../utils/dataFieldUtils';
import gridViewFieldsUtils from '../../utils/gridViewFieldsUtils';
import {
	InventoryFormFormGetters,
	InventoryFormGetters,
} from '../../store/getters';
import { gridViewTypes } from '../../enums/gridViewTypes';
import { mapGetters } from 'vuex';
import { processRecursive } from '../../utils/generalUtils';

export default {
	data() {
		return {
			checkLinkFields_showDialog: false,
			checkLinkFields_gridView: null,
			checkLinkFields_foreignKey: null,
		};
	},
	computed: {
		...mapGetters({
			gridViews: [InventoryFormFormGetters.GRID_VIEWS],
			defaultGridViews: [InventoryFormGetters.GET_GRID_VIEWS],
		}),

		foreignKeys() {
			let fks = [];
			if (!this.formFields) return fks;
			this.formFields.forEach((ff) => {
				if (ff.GridViewFields && ff.GridViewFields.length > 0) {
					ff.GridViewFields.forEach((gvf) => {
						if (gvf.LinkField) {
							let existing = fks.find(
								(x) => x.LinkField.Id == gvf.LinkField.Id
							);
							if (!existing) {
								fks.push({
									LinkField: gvf.LinkField,
									FormFields: [ff],
									EntityId: gvf.DataField.EntityId,
									EntityName: gvf.DataField.EntityName,
								});
							} else {
								let existingFormField =
									existing.FormFields.find(
										(x) => x.Id == ff.Id
									);
								if (!existingFormField) {
									existing.FormFields.push(ff);
								}
							}
						}
					});
				}
			});
			return fks;
		},
	},
	methods: {
		checkLinkField(fk) {
			return new Promise((resolve) => {
				let idKey = dataFieldUtils.getDataFieldName(fk.LinkField);
				if (
					idKey &&
					this.record[idKey] &&
					(this.record[idKey] || this.record[idKey] === -1)
				) {
					resolve(true);
				} else {
					let gridView = this.getGridViewForFk(fk);
					this.checkLinkFields_showDialog = true;
					this.checkLinkFields_gridView = gridView;
					this.checkLinkFields_foreignKey = fk;
					resolve(false);
				}
			});
		},

		buildLinkFieldsCheckList() {
			let list = [];
			this.foreignKeys.forEach((fk) => {
				let push = false;
				fk.FormFields.every((ff) => {
					ff.GridViewFields.every((gvf) => {
						let key = gridViewFieldsUtils.getFieldName(gvf);
						if (this.record[key]) {
							push = true;
							return false;
						}
						return true;
					});
					return !push;
				});
				if (push) {
					list.push(JSON.parse(JSON.stringify(fk)));
				}
			});
			return list;
		},

		checkLinkFields() {
			return new Promise((resolve) => {
				if (!this.foreignKeys) resolve(true);
				if (this.foreignKeys.length <= 0) resolve(true);
				let fks = this.buildLinkFieldsCheckList();
				if (fks.length <= 0) resolve(true);
				processRecursive(fks, this.checkLinkField).then((success) => {
					if (!success) resolve(false);
					resolve(true);
				});
			});
		},

		onCheckLinkFieldsModalClose() {
			this.checkLinkFields_showDialog = false;
			this.checkLinkFields_gridView = null;
			this.checkLinkFields_foreignKey = null;
		},
		async onCheckLinkFieldsModalSubmit() {
			this.onCheckLinkFieldsModalClose();
			await this.onSave();
		},

		getGridViewForFk(fk) {
			if (!fk) return null;
			if (!fk.EntityId) return null;
			let entityId = fk.EntityId;
			let gv = this.gridViews.find(
				(x) =>
					x.Type === gridViewTypes.InventoryFormFilters &&
					x.EntityId == entityId
			);
			if (gv) {
				return gv;
			} else {
				gv = this.defaultGridViews.find(
					(x) =>
						x.Type === gridViewTypes.Grids &&
						x.EntityId == entityId &&
						x.UserId == null
				);
				return gv;
			}
		},
	},
};
